import React,{useState} from 'react';
import { Link } from 'react-router-dom';

// Shared assets
import aboutImg1 from '../assets/images/about-img-1.jpg';
import aboutImg2 from '../assets/images/about-img-2.jpg';
import contactUsImg from '../assets/images/contact-us-img.svg';
import iconFinancialStrategies from '../assets/images/icon-financial-strategies.svg';
import iconPhone from '../assets/images/icon-phone.svg';
import author1 from '../assets/images/author-1.jpg';
import iconService1 from '../assets/images/icon-service-1.svg';
import iconService2 from '../assets/images/icon-service-2.svg';
import iconService3 from '../assets/images/icon-service-3.svg';
import iconService4 from '../assets/images/icon-service-4.svg';
import iconService5 from '../assets/images/icon-service-5.svg';
import iconService6 from '../assets/images/icon-service-6.svg';
import arrowWhite from '../assets/images/arrow-white.svg';
import whyChooseImg1 from '../assets/images/why-choose-img-1.jpg';
import whyChooseImg2 from '../assets/images/why-choose-img-2.jpg';
import iconWhyChoose1 from '../assets/images/icon-why-choose-1.svg';
import iconWhyChoose2 from '../assets/images/icon-why-choose-2.svg';

// Additional images needed for other components
import iconOurFeature1 from '../assets/images/icon-our-feature-1.svg';
import iconOurFeature2 from '../assets/images/icon-our-feature-2.svg';
import iconOurFeature3 from '../assets/images/icon-our-feature-3.svg';
import iconOurFeature4 from '../assets/images/icon-our-feature-4.svg';
import iconOurFeature5 from '../assets/images/icon-our-feature-5.svg';
import iconOurFeature6 from '../assets/images/icon-our-feature-6.svg';
import iconFactCounter1 from '../assets/images/icon-fact-counter-1.svg';
import iconFactCounter2 from '../assets/images/icon-fact-counter-2.svg';
import iconFactCounter3 from '../assets/images/icon-fact-counter-3.svg';
import factCounterImg from '../assets/images/fact-counter-img.jpg';
import factCounterSkillbar from '../assets/images/fact-counter-skillbar-img.png';
import whatWeDoImg1 from '../assets/images/what-we-do-img-1.jpg';
import whatWeDoImg2 from '../assets/images/what-we-do-img-2.jpg';
import faqsImg from '../assets/images/faqs-img.jpg';
import satisfyClient1 from '../assets/images/satisfy-client-img-1.jpg';
import satisfyClient2 from '../assets/images/satisfy-client-img-2.jpg';
import satisfyClient3 from '../assets/images/satisfy-client-img-3.jpg';
import satisfyClient4 from '../assets/images/satisfy-client-img-4.jpg';
import satisfyClient5 from '../assets/images/satisfy-client-img-5.jpg';
import customerLogo from '../assets/images/customer-logo.svg';
import testimonialQuotes from '../assets/images/testimonial-quotes.svg';
import author2 from '../assets/images/author-2.jpg';
import author3 from '../assets/images/author-3.jpg';
import iconGoogle from '../assets/images/icon-google.svg';
import customerRatingImg from '../assets/images/customer-rating-img.svg';
import post1 from '../assets/images/post-1.jpg';
import post2 from '../assets/images/post-2.jpg';
import post3 from '../assets/images/post-3.jpg';
import post4 from '../assets/images/post-4.jpg';
import iconPricingBenefit1 from '../assets/images/icon-pricing-benefit-1.svg';
import iconPricingBenefit2 from '../assets/images/icon-pricing-benefit-2.svg';
import iconPricingBenefit3 from '../assets/images/icon-pricing-benefit-3.svg';

// Shared Components
const AnimatedCharacter = ({ char }) => (
  <div style={{
    position: "relative",
    display: "inline-block",
    opacity: 1,
    visibility: "inherit",
    transform: "translate(0px, 0px)"
  }}>
    <div style={{ position: "relative", display: "inline-block" }}>
      <div style={{
        position: "relative",
        display: "inline-block",
        transform: "translate(0px, 0px)",
        opacity: 1
      }}>
        {char}
      </div>
    </div>
  </div>
);

const AnimatedTextLine = ({ text }) => (
  <div className="split-line" style={{
    display: "block",
    textAlign: "start",
    position: "relative"
  }}>
    <span>
      {text.split('').map((char, index) => (
        <AnimatedCharacter key={index} char={char} />
      ))}
    </span>
  </div>
);

// AboutUs Component
function AboutUs() {
  const titleLines = ["Trusted guidance for", "financial growth"];

  return (
    <div className="about-us">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="about-us-images">
              <div className="about-img-1">
                <figure className="image-anime reveal" style={{ transform: "translate(0px, 0px)", opacity: 1, visibility: "inherit" }}>
                  <img src={aboutImg1} alt="About our company" style={{ transform: "translate(0px, 0px)" }} />
                </figure>
              </div>

              <div className="about-img-2">
                <figure className="image-anime reveal" style={{ transform: "translate(0px, 0px)", opacity: 1, visibility: "inherit" }}>
                  <img src={aboutImg2} alt="Our team working" style={{ transform: "translate(0px, 0px)" }} />
                </figure>
              </div>

              <div className="contact-circle">
                <img src={contactUsImg} alt="Contact us" />
              </div>
            </div>
          </div>
          
          <div className="col-lg-6">
            <div className="about-us-content">
              <div className="section-title">
                <h3 className="wow fadeInUp" style={{ visibility: "visible", animationName: "fadeInUp" }}>
                  about us
                </h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque" style={{ perspective: "400px" }}>
                  Trusted guidance for financial growth
                </h2>
                <p className="wow fadeInUp" data-wow-delay="0.2s" style={{ 
                  visibility: "visible", 
                  animationDelay: "0.2s", 
                  animationName: "fadeInUp" 
                }}>
                  With years of expertise in finance and consulting, we provide tailored strategies to help you achieve sustainable growth. Our commitment is to guide you with integrity, insight, and a personalized approach.
                </p>
              </div>

              <div className="about-content-body">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="about-content-info">
                      <div 
                        className="about-goal-box wow fadeInUp" 
                        data-wow-delay="0.4s" 
                        style={{ 
                          visibility: "visible", 
                          animationDelay: "0.4s", 
                          animationName: "fadeInUp" 
                        }}
                      >
                        <div className="icon-box">
                          <img src={iconFinancialStrategies} alt="Financial strategies icon" />
                        </div>
                        <div className="about-goal-box-content">
                          <h3>financial strategies</h3>
                          <p>Tailored plans to meet your unique financial needs and goals.</p>
                        </div>
                      </div>
            
                      {/* <div 
                        className="about-contact-box wow fadeInUp" 
                        data-wow-delay="0.6s" 
                        style={{ 
                          visibility: "visible", 
                          animationDelay: "0.6s", 
                          animationName: "fadeInUp" 
                        }}
                      >
                        <div className="icon-box">
                          <img src={iconPhone} alt="Phone icon" />
                        </div>
                        <div className="about-contact-content">
                          <p><a href="tel:658456975">91-7339983554</a></p>
                        </div>
                      </div> */}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div 
                      className="about-author-box wow fadeInUp" 
                      data-wow-delay="0.4s" 
                      style={{ 
                        visibility: "visible", 
                        animationDelay: "0.4s", 
                        animationName: "fadeInUp" 
                      }}
                    >
                      <div className="about-info-box">
                        <figure className="image-anime reveal" style={{ 
                          transform: "translate(0px, 0px)", 
                          opacity: 1, 
                          visibility: "inherit" 
                        }}>
                          <img src={author1} alt="Sarah T. - Co-founder" style={{ transform: "translate(0px, 0px)" }} />
                        </figure>
                        <div className="about-author-content">
                          <h3>Sarah T.</h3>
                          <p>Co. founder</p>
                        </div>
                      </div>
                      <div className="about-info-list">
                        <ul>
                          <li>risk management</li>
                          <li>communication</li>
                          <li>24/7 support</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// OurServices Component
function OurServices() {
  const titleLines = ["Expert finance &", "consult services for", "success"];

  const services = [
    {
      id: 1,
      title: "Digital Payments",
      description: "Simplify transactions with secure UPI, card, and wallet payment solutions designed for businesses of all sizes.",
      icon: iconService1,
      active: false
    },
    {
      id: 2,
      title: "Payment Gateway Integration",
      description: "Fast, reliable, and scalable payment gateway services to help businesses accept online payments seamlessly.",
      icon: iconService2,
      active: true
    },
    {
      id: 3,
      title: "Merchant Solutions",
      description: "Comprehensive tools for merchants including invoicing, POS integration, settlement reports, and fraud protection.",
      icon: iconService3,
      active: false
    },
    {
      id: 4,
      title: "Lending & Credit Solutions",
      description: "Smart credit scoring and digital lending platforms to empower businesses and individuals with easy access to finance.",
      icon: iconService4,
      active: false
    },
    {
      id: 5,
      title: "Wallet & Prepaid Cards",
      description: "Custom digital wallets and prepaid card solutions for customers, offering flexibility and instant money transfers.",
      icon: iconService5,
      active: false
    },
    {
      id: 6,
      title: "Financial Analytics & Reporting",
      description: "Advanced dashboards with real-time insights, helping businesses track transactions, revenue, and financial growth.",
      icon: iconService6,
      active: false
    }
  ];

  return (
    <div className="our-services">
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <div className="our-service-content">
              <div className="section-title">
                <h3 className="wow fadeInUp" style={{ visibility: "visible", animationName: "fadeInUp" }}>
                  services
                </h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque" style={{ perspective: "400px" }}>
                  {titleLines.map((line, index) => (
                    <AnimatedTextLine key={index} text={line} />
                  ))}
                </h2>
              </div>
              <div 
                className="service-content-btn wow fadeInUp" 
                data-wow-delay="0.25s" 
                style={{ 
                  visibility: "visible", 
                  animationDelay: "0.25s", 
                  animationName: "fadeInUp" 
                }}
              >
                <Link to="/services" className="btn-default">all services</Link>
              </div>
            </div>
          </div>

          <div className="col-lg-8">
            <div className="our-service-list">
              {services.map((service) => (
                <div 
                  key={service.id} 
                  className={`service-item ${service.active ? 'active' : ''}`}
                >
                  <div className="service-no">
                    <h2>{service.id.toString().padStart(2, '0')}</h2>
                  </div>
                  <div className="service-content-box">
                    <div className="icon-box">
                      <img src={service.icon} alt={`${service.title} icon`} />
                    </div>
                    <div className="service-item-content">
                      <h3>{service.title}</h3>
                      <p>{service.description}</p>
                      <Link to="/service-single" className="service-btn">
                        <img src={arrowWhite} alt="View service" />
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div 
              className="service-footer wow fadeInUp" 
              data-wow-delay="0.8s" 
              style={{ 
                visibility: "hidden", 
                animationDelay: "0.8s", 
                animationName: "none" 
              }}
            >
              <p>Let's make something great work together. <Link to="/contact">Get Free Quote</Link></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// WhyChooseUs Component
function WhyChooseUs() {
  const titleLines = [
    "Why trust us our",
    "finance services"
  ];

  const whyChooseItems = [
    {
      id: 1,
      title: "Secure & Scalable Technology",
      description: "Our Click4pay solutions are built on robust security frameworks and scalable infrastructure, ensuring your business can grow confidently without compromising on safety.",
      icon: iconWhyChoose1
    },
    {
      id: 2,
      title: "Customer-Centric Approach",
      description: "We design our services with your success in mind — providing seamless user experiences, 24/7 support, and innovative tools that make financial operations simple and efficient.",
      icon: iconWhyChoose2
    }
  ];

  const featuresList = [
    "strategic financial planning",
    "expert investment advisory"
  ];

  return (
    <div className="why-choose-us">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="why-choose-content">
              <div className="section-title">
                <h3 className="wow fadeInUp" style={{ visibility: "visible", animationName: "fadeInUp" }}>
                  why choose us
                </h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque" style={{ perspective: "400px" }}>
                  {titleLines.map((line, index) => (
                    <AnimatedTextLine key={index} text={line} />
                  ))}
                </h2>
              </div>

              <div className="why-choose-box-list">
                {whyChooseItems.map((item, index) => (
                  <div 
                    key={item.id}
                    className="why-choose-box wow fadeInUp" 
                    data-wow-delay={`${0.2 + (index * 0.1)}s`} 
                    style={{ 
                      visibility: "visible", 
                      animationDelay: `${0.2 + (index * 0.1)}s`, 
                      animationName: "fadeInUp" 
                    }}
                  >
                    <div className="icon-box">
                      <img src={item.icon} alt={`${item.title} icon`} />
                    </div>
                    <div className="why-choose-box-content">
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div 
                className="why-choose-list wow fadeInUp" 
                data-wow-delay="0.4s" 
                style={{ 
                  visibility: "visible", 
                  animationDelay: "0.4s", 
                  animationName: "fadeInUp" 
                }}
              >
                <ul>
                  {featuresList.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="why-choose-image">
              <div className="why-choose-img-1">
                <figure className="image-anime reveal" style={{ 
                  transform: "translate(0px, 0px)", 
                  opacity: 1, 
                  visibility: "inherit" 
                }}>
                  <img src={whyChooseImg1} alt="Financial consultation" style={{ transform: "translate(0px, 0px)" }} />
                </figure>
              </div>

              <div className="why-choose-img-2">
                <figure className="image-anime reveal" style={{ 
                  transform: "translate(0px, 0px)", 
                  opacity: 1, 
                  visibility: "inherit" 
                }}>
                  <img src={whyChooseImg2} alt="Team meeting" style={{ transform: "translate(0px, 0px)" }} />
                </figure>
              </div>

              <div className="why-choose-contact-circle">
                <img src={contactUsImg} alt="Contact us" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const OurFeature = () => {
  const features = [
    {
      icon: iconOurFeature1,
      title: 'Seamless Integration',
      description: 'Easily connect our fintech solutions with your existing systems for a hassle-free experience.'
    },
    {
      icon: iconOurFeature2,
      title: 'High Security Standards',
      description: 'End-to-end encryption and fraud detection ensure every transaction is safe.'
    },
    {
      icon: iconOurFeature3,
      title: 'Real-Time Processing',
      description: 'Instant payments, settlements, and updates keep your business running smoothly.'
    },
    {
      icon: iconOurFeature4,
      title: 'Customizable Solutions',
      description: 'Tailored fintech products to match your business model and customer needs.'
    },
    {
      icon: iconOurFeature5,
      title: '24/7 Support',
      description: 'Dedicated technical and customer support whenever you need assistance.'
    },
    {
      icon: iconOurFeature6,
      title: 'Analytics & Insights',
      description: 'Smart dashboards and reports help you make data-driven business decisions.'
    }
  ];

  return (
    <div className="our-feature">
      <div className="container">
        <div className="row section-row align-items-center">
          <div className="col-lg-6">
            <div className="section-title dark-section">
              <h3 className="wow fadeInUp">our feature</h3>
              <h2 className="text-anime-style-2" data-cursor="-opaque">
                Key features of our finance and consultancy
              </h2>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="section-btn wow fadeInUp" data-wow-delay="0.2s">
              <Link to="/contact" className="btn-default">contact now</Link>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="our-feature-list">
              {features.map((feature, index) => (
                <div 
                  key={index}
                  className={`our-feature-item wow fadeInUp${index > 0 ? ` data-wow-delay="${0.2 * index}s"` : ''}`}
                >
                  <div className="icon-box">
                    <img src={feature.icon} alt="" />
                  </div>
                  <div className="feature-item-content">
                    <h3>{feature.title}</h3>
                    <p>{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-lg-12">
            <div className="our-feature-footer wow fadeInUp" data-wow-delay="1.2s">
              <p><span>Free</span> Let's make something great work together. <Link to="/contact">Get Free Quote</Link></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const FactCounter = () => {
  const facts = [
    {
      icon: iconFactCounter1,
      value: 5,
      suffix: '+',
      label: 'Years of experience'
    },
    {
      icon: iconFactCounter2,
      value: 80,
      suffix: '%+',
      label: 'Client success rate'
    },
    {
      icon: iconFactCounter3,
      value: 20,
      suffix: '+',
      label: 'global research'
    }
  ];

  return (
    <div className="fact-counter">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="fact-counter-image">
              <div className="fact-counter-img">
                <figure className="image-anime reveal">
                  <img src={factCounterImg} alt="" />
                </figure>
              </div>
              <div className="fact-counter-skillbar">
                <img src={factCounterSkillbar} alt="" />
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="fact-counter-content">
              <div className="section-title">
                <h3 className="wow fadeInUp">some facts</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  Key facts our expertise
                </h2>
                <p className="wow fadeInUp" data-wow-delay="0.2s">
                  Our expertise is built on years of industry experience, proven financial strategies and a commitment to client success.
                </p>
              </div>

              <div className="fact-counter-box-list">
                {facts.map((fact, index) => (
                  <div key={index} className="fact-counter-box">
                    <div className="icon-box">
                      <img src={fact.icon} alt="" />
                    </div>
                    <div className="fact-counter-box-content">
                      <h2><span className="counter">{fact.value}</span>{fact.suffix}</h2>
                      <p>{fact.label}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="fact-counter-list wow fadeInUp" data-wow-delay="0.4s">
                <ul>
                  <li>Strategic financial planning</li>
                  <li>Expert investment advisory</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const WhatWeDo = () => {
  const services = [
    'strategic financial planning',
    'expert investment advisory',
    'risk assessment & mitigation',
    'retirement & future planning'
  ];

  return (
    <div className="what-we-do">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="what-we-do-content">
              <div className="section-title">
                <h3 className="wow fadeInUp">what we do</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  Driving financial growth and consultancy
                </h2>
                <p className="wow fadeInUp" data-wow-delay="0.2s">
                  We provide expert financial and consulting solutions designed to foster growth, stability, and long-term success.
                </p>
              </div>

              <div className="what-we-do-list wow fadeInUp" data-wow-delay="0.4s">
                <ul>
                  {services.map((service, index) => (
                    <li key={index}>{service}</li>
                  ))}
                </ul>
              </div>

              <div className="what-we-do-btn wow fadeInUp" data-wow-delay="0.6s">
                <Link to="/contact" className="btn-default">contact now</Link>
              </div>
            </div>
          </div>
          
          <div className="col-lg-6">
            <div className="what-we-do-images">
              <div className="what-do-we-img-1">
                <figure className="image-anime reveal">
                  <img src={whatWeDoImg1} alt="" />
                </figure>
              </div>
              <div className="what-do-we-img-2">
                <figure className="image-anime reveal">
                  <img src={whatWeDoImg2} alt="" />
                </figure>
              </div>
              <div className="experience-counter-box">
                <div className="experience-counter-no">
                  <h2><span className="counter">5</span>+</h2>
                </div>
                <div className="experience-counter-content">
                  <p>Years of experience in finance</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const HowItWork = () => {
  const steps = [
    {
      title: 'Sign Up & Get Started',
      description: 'Create your Click4pay account in minutes and access our secure fintech platform.',
      number: '01'
    },
    {
      title: 'Integrate & Customize',
      description: 'Connect our payment and financial solutions with your business, tailored to your needs.',
      number: '02'
    },
    {
      title: 'Transact & Grow',
      description: 'Start accepting payments, managing finances, and scaling your business with real-time insights.',
      number: '03'
    }
  ];

  return (
    <div className="how-it-work">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="how-it-work-content">
              <div className="section-title">
                <h3 className="wow fadeInUp">how it work</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  Our process for financial consultancy
                </h2>
                <p className="wow fadeInUp" data-wow-delay="0.2s">
                  Our process is designed to guide you every step of the way. From initial consultation to personalized strategy development.
                </p>
              </div>

              <div className="how-it-work-btn wow fadeInUp" data-wow-delay="0.4s">
                <Link to="/contact" className="btn-default">learn more</Link>
              </div>
            </div>
          </div>
          
          <div className="col-lg-6">
            <div className="work-steps-box">
              {steps.map((step, index) => (
                <div 
                  key={index}
                  className={`work-step-item wow fadeInUp${index > 0 ? ` data-wow-delay="${0.2 * index}s"` : ''}`}
                >
                  <div className="work-step-item-content">
                    <h3>step</h3>
                    <h2>{step.title}</h2>
                    <p>{step.description}</p>
                  </div>
                  <div className="work-step-item-no">
                    <h2>{step.number}</h2>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};  

const OurPricing = () => {
  // const plans = [
  //   {
  //     name: 'personal plan',
  //     price: 29.00,
  //     period: '/per month',
  //     features: [
  //       'comprehensive financial analysis',
  //       'tax strategy optimization',
  //       'regular progress reports',
  //       'ongoing support and guidance'
  //     ],
  //     highlighted: false
  //   },
  //   {
  //     name: 'business plan',
  //     price: 39.00,
  //     period: '/per month',
  //     features: [
  //       'comprehensive financial analysis',
  //       'tax strategy optimization',
  //       'regular progress reports',
  //       'ongoing support and guidance'
  //     ],
  //     highlighted: true
  //   },
  //   {
  //     name: 'advance plan',
  //     price: 49.00,
  //     period: '/per month',
  //     features: [
  //       'comprehensive financial analysis',
  //       'tax strategy optimization',
  //       'regular progress reports',
  //       'ongoing support and guidance'
  //     ],
  //     highlighted: false
  //   }
  // ];

  // const benefits = [
  //   { icon: iconPricingBenefit1, text: 'Get 30 day free trial' },
  //   { icon: iconPricingBenefit2, text: 'No any hidden fees pay' },
  //   { icon: iconPricingBenefit3, text: 'You can cancel anytime' }
  // ];

  // return (
  //   <div className="our-pricing">
  //     <div className="container">
  //       <div className="row section-row align-items-center">
  //         <div className="col-lg-5">
  //           <div className="section-title">
  //             <h3 className="wow fadeInUp">pricing plan</h3>
  //             <h2 className="text-anime-style-2" data-cursor="-opaque">
  //               Flexible pricing plans for your finance
  //             </h2>
  //           </div>
  //         </div>

  //         <div className="col-lg-7">
  //           <div className="section-btn wow fadeInUp" data-wow-delay="0.2s">
  //             <Link to="/contact" className="btn-default">contact now</Link>
  //           </div>
  //         </div>
  //       </div>

  //       <div className="row">
  //         {plans.map((plan, index) => (
  //           <div key={index} className="col-lg-4 col-md-6">
  //             <div className={`pricing-box wow fadeInUp${index > 0 ? ` data-wow-delay="${0.2 * index}s"` : ''}${plan.highlighted ? ' highlighted-box' : ''}`}>
  //               <div className="pricing-header">
  //                 <h3>{plan.name}</h3>
  //                 <h2><sup>$</sup>{plan.price.toFixed(2)}<sub>{plan.period}</sub></h2>
  //               </div>

  //               <div className="pricing-body">
  //                 <div className="pricing-list-title">
  //                   <h3>What's included?</h3>
  //                 </div>
  //                 <div className="pricing-list">
  //                   <ul>
  //                     {plan.features.map((feature, idx) => (
  //                       <li key={idx}>{feature}</li>
  //                     ))}
  //                   </ul>
  //                 </div>
  //               </div>

  //               <div className="pricing-btn">
  //                 <Link to="/contact" className="btn-default btn-highlighted">Select this package</Link>
  //               </div>
  //             </div>
  //           </div>
  //         ))}

  //         <div className="col-lg-12">
  //           <div className="pricing-benefit-list wow fadeInUp" data-wow-delay="0.6s">
  //             <ul>
  //               {benefits.map((benefit, index) => (
  //                 <li key={index}>
  //                   <img src={benefit.icon} alt="" />
  //                   {benefit.text}
  //                 </li>
  //               ))}
  //             </ul>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );
};

const OurFaqs = () => {
  const [activeAccordion, setActiveAccordion] = useState(1);

  const faqs = [
    {
      id: 1,
      question: 'What services do you offer?',
      answer: "If you're uncertain about managing investments, planning for retirement, or structuring your finances, consulting a financial professional can help. Our team assists in clarifying your goals, optimizing your strategies."
    },
    {
      id: 2,
      question: 'How do I know if I need a financial consultant?',
      answer: "If you're uncertain about managing investments, planning for retirement, or structuring your finances, consulting a financial professional can help. Our team assists in clarifying your goals, optimizing your strategies."
    },
    {
      id: 3,
      question: 'What can I expect from an initial consultation?',
      answer: "If you're uncertain about managing investments, planning for retirement, or structuring your finances, consulting a financial professional can help. Our team assists in clarifying your goals, optimizing your strategies."
    },
    {
      id: 4,
      question: 'Are my consultations confidential?',
      answer: "If you're uncertain about managing investments, planning for retirement, or structuring your finances, consulting a financial professional can help. Our team assists in clarifying your goals, optimizing your strategies."
    },
    {
      id: 5,
      question: 'What kind of clients do you work with?',
      answer: "If you're uncertain about managing investments, planning for retirement, or structuring your finances, consulting a financial professional can help. Our team assists in clarifying your goals, optimizing your strategies."
    }
  ];

  const clients = [
    satisfyClient1,
    satisfyClient2,
    satisfyClient3,
    satisfyClient4,
    satisfyClient5
  ];

  return (
    <div className="our-faqs">
      <div className="container">
        <div className="row section-row align-items-center">
          <div className="col-lg-6">
            <div className="section-title">
              <h3 className="wow fadeInUp">faqs</h3>
              <h2 className="text-anime-style-2" data-cursor="-opaque">
                Your most frequently asked questions answered
              </h2>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="section-btn wow fadeInUp" data-wow-delay="0.2s">
              <Link to="/faqs" className="btn-default">view all FAQs</Link>
            </div>
          </div>
        </div>

        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="our-faqs-image">
              <div className="our-faqs-img">
                <figure className="image-anime reveal">
                  <img src={faqsImg} alt="" />
                </figure>
              </div>

              <div className="client-review-box">
                <div className="client-review-box-content">
                  <p>100+ Client <span><i className="fa-solid fa-star"></i> 5.0 (250 Reviews)</span></p>
                </div>

                <div className="client-review-images">
                  {clients.map((client, index) => (
                    <div key={index} className="client-image">
                      <figure className="image-anime">
                        <img src={client} alt="" />
                      </figure>
                    </div>
                  ))}
                  <div className="client-image add-more">
                    <p><span className="counter">30</span>+</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-lg-6">
            <div className="our-faq-section">
              <div className="faq-accordion">
                {faqs.map((faq, index) => (
                  <div 
                    key={faq.id}
                    className={`accordion-item wow fadeInUp${index > 0 ? ` data-wow-delay="${0.2 * index}s"` : ''}`}
                  >
                    <h2 className="accordion-header">
                      <button 
                        className={`accordion-button ${activeAccordion === faq.id ? '' : 'collapsed'}`}
                        onClick={() => setActiveAccordion(activeAccordion === faq.id ? null : faq.id)}
                      >
                        {faq.question}
                      </button>
                    </h2>
                    <div 
                      className={`accordion-collapse collapse ${activeAccordion === faq.id ? 'show' : ''}`}
                    >
                      <div className="accordion-body">
                        <p>{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const OurTestimonial = () => {
  const testimonials = [
    {
      author: 'sarah t.',
      role: 'entrepreneur',
      quote: '"The guidance we received has transformed our financial outlook. Our consultant was patient, knowledgeable, and crafted a plan that aligned perfectly with our goals. Thanks to their strategic advice, optimistic about our future!"',
      image: author1
    },
    {
      author: 'ellyse p.',
      role: 'finance manager',
      quote: '"The guidance we received has transformed our financial outlook. Our consultant was patient, knowledgeable, and crafted a plan that aligned perfectly with our goals. Thanks to their strategic advice, optimistic about our future!"',
      image: author2
    },
    {
      author: 'robert t.',
      role: 'accounts manager',
      quote: '"The guidance we received has transformed our financial outlook. Our consultant was patient, knowledgeable, and crafted a plan that aligned perfectly with our goals. Thanks to their strategic advice, optimistic about our future!"',
      image: author3
    }
  ];

  return (
    <div className="our-testimonial">
      <div className="container">
        <div className="row">
          <div className="col-lg-5">
            <div className="testimonial-content">
              <div className="section-title dark-section">
                <h3 className="wow fadeInUp">our testimonial</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  1250+ customers say about our finance
                </h2>
                <p className="wow fadeInUp" data-wow-delay="0.2s">
                  With over 1,250 satisfied clients, our finance and consulting services have earned praise for reliability, personalized guidance, and impactful results.
                </p>
              </div>

              <div className="testimonial-btn">
                <Link to="/contact" className="btn-default">contact now</Link>
              </div>
            </div>
          </div>

          <div className="col-lg-7">
            <div className="testimonial-slider-box">
              <div className="testimonial-slider">
                <div className="testimonial-item">
                  <div className="testimonial-header">
                    <div className="customer-logo">
                      <img src={customerLogo} alt="" />
                    </div>
                    <div className="testimonial-quotes">
                      <img src={testimonialQuotes} alt="" />
                    </div>
                  </div>
                  <div className="testimonial-body">
                    <p>{testimonials[0].quote}</p>
                  </div>
                  <div className="testimonial-author">
                    <div className="author-image">
                      <figure className="image-anime">
                        <img src={testimonials[0].image} alt="" />
                      </figure>
                    </div>
                    <div className="author-content">
                      <h3>{testimonials[0].author} / <span>{testimonials[0].role}</span></h3>
                    </div>
                  </div>
                </div>
              </div>

              <div className="customer-rating-boxes">
                <div className="customer-rating-box">
                  <div className="customer-rating-image">
                    <img src={iconGoogle} alt="" />
                  </div>
                  <div className="customer-rating-content">
                    <p>google rating</p>
                    <div className="customer-rating-counter">
                      <h3><span className="counter">5.0</span></h3>
                      <div className="customer-rating-star">
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="customer-rating-box">
                  <div className="customer-rating-counter">
                    <p><span className="counter">5.0</span> rated</p>
                  </div>
                  <div className="customer-rating-star-box">
                    <div className="customer-rating-star">
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                    </div>
                    <div className="star-rating-img">
                      <img src={customerRatingImg} alt="" />
                    </div>
                  </div>
                </div>

                <div className="customer-rating-box customer-rating-content">
                  <p>Total rating <span className="counter">5.0</span> base on 1250+ review</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const OurBlog = () => {
  // const posts = [
  //   {
  //     image: post1,
  //     date: '15 sep, 2024',
  //     title: '10 Essential Steps to Create Foolproof Financial Plan for Long-Term Stability'
  //   },
  //   {
  //     image: post2,
  //     date: '15 sep, 2024',
  //     title: 'Top 10 Financial Mistakes Individuals and Businesses Should Avoid in 2024'
  //   },
  //   {
  //     image: post3,
  //     date: '15 sep, 2024',
  //     title: 'Mastering Budgeting Practical Steps to Ensure Your Financial Success'
  //   },
  //   {
  //     image: post4,
  //     date: '15 sep, 2024',
  //     title: 'Understanding Cash Flow Key to Healthy Busines and Financial Stability'
  //   }
  // ];

  // return (
  //   <div className="our-blog">
  //     <div className="container">
  //       <div className="row section-row">
  //         <div className="col-lg-6">
  //           <div className="section-title">
  //             <h3 className="wow fadeInUp">blog / post</h3>
  //             <h2 className="text-anime-style-2" data-cursor="-opaque">
  //               Finance insights, updates, and trends
  //             </h2>
  //           </div>
  //         </div>

  //         <div className="col-lg-6">
  //           <div className="section-btn wow fadeInUp" data-wow-delay="0.2s">
  //             <Link to="/blog" className="btn-default">view all post</Link>
  //           </div>
  //         </div>
  //       </div>

  //       <div className="row">
  //         {posts.map((post, index) => (
  //           <div key={index} className="col-md-6">
  //             <div className={`post-item wow fadeInUp${index > 0 ? ` data-wow-delay="${0.2 * index}s"` : ''}`}>
  //               <div className="post-featured-image">
  //                 <Link to="/blog-single" data-cursor-text="View">
  //                   <figure className="image-anime">
  //                     <img src={post.image} alt="" />
  //                   </figure>
  //                 </Link>
  //               </div>
  //               <div className="post-item-body">
  //                 <div className="post-item-meta">
  //                   <ul>
  //                     <li><i className="fa-solid fa-calendar-days"></i> {post.date}</li>
  //                   </ul>
  //                 </div>
  //                 <div className="post-item-content">
  //                   <h2><Link to="/blog-single">{post.title}</Link></h2>
  //                 </div>
  //                 <div className="post-item-btn">
  //                   <Link to="/blog-single" className="readmore-btn">read more</Link>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         ))}
  //       </div>
  //     </div>
  //   </div>
  // );
};
// Export all components
export {AboutUs, OurServices ,WhyChooseUs,OurFeature ,FactCounter ,WhatWeDo ,HowItWork ,OurPricing ,OurFaqs ,OurTestimonial ,OurBlog };
